import {
  type schemaType,
  type returnType,
} from '~~/shared/api/strapi/escapadas/list/schema'
import {
  strapiServerFetchWrapper,
  strapiBrowserFetchWrapper,
} from '~~/server/utils/strapi/endpointWrapper'

const endpoint = '/escapadas/list'

export const serverFetch = (): Promise<returnType> =>
  strapiServerFetchWrapper<never, schemaType>(endpoint)

export const browserFetch = (): Promise<returnType> =>
  strapiBrowserFetchWrapper<never, schemaType>(endpoint)
